import React from 'react'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import AssetCardByGroup from './AssetCardByGroup'

// Stable identity for "no locations": an inline [] would mint a new array per render
// for every location-less card, defeating AssetCardByGroup's React.memo.
const EMPTY_LOCATIONS = []

/**
 * AssetGrid — paints the already-filtered devices (cell x quick-filter intersection,
 * RN9) as Stitch machine cards (`AssetCardByGroup`). Plain CSS grid (byGroup.css)
 * capped at 3 cards per row maximum (PO directive — never 4+), so each card keeps
 * the width/presence of the mockup. When the intersection is empty (V3/CELL_EMPTY,
 * S19) shows a clear message instead of a blank area; the KPI bar is untouched by
 * this (RN2). `actualLocations`/`onItemClick` are threaded through so each card
 * carries the real operative actions via the shared `AssetCardDialogs` (RN17/RN18).
 *
 * Memoized: the screen re-renders on every 2s poll tick (the interval hook toggles
 * state to reschedule itself); with identity-stable props (see setIntervalData's
 * guards) the whole grid — and every card below — skips those re-renders.
 */
function AssetGrid ({ devices = [], actualLocations = {}, mainImages = {}, onItemClick, onOpenDetail = () => {}, onMainImageChange = () => {}, refreshToken, viewMode = 'compact' }) {
  const { t_ } = useSmartTranslation()

  return (
    <div className={`mcx-grid${viewMode === 'production' ? ' mcx-grid--production' : ''}`}>
      {devices.length === 0 && (
        <p data-testid='asset-grid-empty' className='mcx-empty'>
          {t_('No assets match the selected filter')}
        </p>
      )}
      {devices.map((device) => (
        <AssetCardByGroup
          key={`device-${device.id}`}
          device={device}
          locations={device.id in actualLocations ? actualLocations[device.id] : EMPTY_LOCATIONS}
          mainImageInfo={mainImages[device.id]}
          onItemClick={onItemClick}
          onOpenDetail={onOpenDetail}
          onMainImageChange={onMainImageChange}
          refreshToken={refreshToken}
          viewMode={viewMode}
        />
      ))}
    </div>
  )
}

export default React.memo(AssetGrid)
